/*
 * @Author: wangkg wangkegui@longfor.com
 * @Date: 2022-12-23 07:52:23
 * @LastEditors: wangkg wangkegui@longfor.com
 * @LastEditTime: 2022-12-23 07:53:19
 * @FilePath: /unified-development-platform/src/apis/auth/move-auth/platform/organization_api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { request } from '@/apis/request'
const PRE_PATH = '/v1/sys'

export function auth_users(orgNo, data) {
  return request({
    url: `${PRE_PATH}/org/auth/${orgNo}`,
    method: 'post',
    data,
    rd: true
  })
}

export function add_org(data) {
  return request({
    url: `${PRE_PATH}/org`,
    method: 'post',
    data,
    rd: true
  })
}

export function update_org_by_no(orgNo, data) {
  return request({
    url: `${PRE_PATH}/org/${orgNo}`,
    method: 'post',
    data,
    rd: true
  })
}


export function delete_org_by_no(orgNo) {
  return request({
    url: `${PRE_PATH}/org/${orgNo}`,
    method: 'delete',
    rd: true
  })
}


export function get_user_of_org(orgNo) {
  return request({
    url: `${PRE_PATH}/org/users/${orgNo}`,
    method: 'get',
    rd: true
  })
}


// export function check_org_name(orgName, orgNo) {
//     return request({
//         url: `/v1/sys/org/orgName?orgName=${orgName}&orgNo=${orgNo}`,
//         method: 'get',
//         rd: true
//     })
// }
export const check_org_name = (orgName, orgNo) => {
  return `/v1/sys/org/orgName?orgName=${orgName}&orgNo=${orgNo}`
}


export function get_orgs(params) {
  return request({
    url: `${PRE_PATH}/org`,
    method: 'get',
    params: params,
    rd: true
  })
}